import { styled } from "@mui/material/styles";
import { ValueFormatterParams } from "ag-grid-community";

export const durationRenderer = (params: ValueFormatterParams) => {
  const duration = params.value;
  return `${duration?.value} ${duration?.unit}`;
}

export const fullNameRenderer = (params: ValueFormatterParams) => {
  return params.data.person.firstName + ' ' + params.data.person.lastName;
}

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

export const convertUnixTime = (initialTime: number) => {
  const initialDate = new Date(initialTime * 1000);
  initialDate.setHours(16, 0, 0, 0);
  const finalUnixTime = Math.floor(initialDate.getTime() / 1000);
  return finalUnixTime;
};